import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/loginView.vue'
import CategoryView from '../views/CategoryView.vue'
import TrendView from '../views/TrendView.vue'
import BetView from '../views/BetView.vue'
import RoadmapView from '../views/RoadmapView.vue'
import RecordView from '../views/RecordView.vue'
import ChaseView from '../views/ChaseView.vue'
import AdminLayout from '../admin/layout/AdminLayout.vue'

const routes = [
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import('../admin/views/Login.vue'),
    meta: { admin: true, public: true }
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { admin: true },
    redirect: '/admin/dashboard',
    children: [
      { path: 'dashboard', name: 'admin-dashboard', component: () => import('../admin/views/Dashboard.vue') },
      { path: 'reports', name: 'admin-reports', component: () => import('../admin/views/Reports.vue') },
      { path: 'games', name: 'admin-games', component: () => import('../admin/views/Games.vue') },
      { path: 'game-visibility', name: 'admin-game-visibility', component: () => import('../admin/views/GameVisibility.vue') },
      { path: 'platform-entry', name: 'admin-platform-entry', component: () => import('../admin/views/PlatformEntry.vue') },
      { path: 'odds', name: 'admin-odds', component: () => import('../admin/views/Odds.vue') },
      { path: 'draws', name: 'admin-draws', component: () => import('../admin/views/Draws.vue') },
      { path: 'draw-source', name: 'admin-draw-source', component: () => import('../admin/views/DrawSource.vue') },
      { path: 'orders', name: 'admin-orders', component: () => import('../admin/views/Orders.vue') },
      { path: 'players', name: 'admin-players', component: () => import('../admin/views/Players.vue') },
      { path: 'recommend', name: 'admin-recommend', component: () => import('../admin/views/Recommend.vue') },
      { path: 'announcements', name: 'admin-announcements', component: () => import('../admin/views/Announcements.vue') },
      { path: 'merchant', name: 'admin-merchant', component: () => import('../admin/views/Merchant.vue') }
    ]
  },
  {
    path: '/',
    name: 'lobby',
    component: LoginView,
  },
  {
    path: '/category',
    name: 'category',
    component: CategoryView,
  },
  {
    path: '/bet',
    name: 'bet',
    component: BetView,
  },
  {
    path: '/bet/tc-lhc',
    name: 'bet-tc-lhc',
    component: () => import('../views/TcLhcBetView.vue'),
  },
  {
    path: '/bet/tc-k3',
    name: 'bet-tc-k3',
    component: () => import('../views/TcK3BetView.vue'),
  },
  {
    path: '/bet/tc-keno8',
    name: 'bet-tc-keno8',
    component: () => import('../views/TcKeno8BetView.vue'),
  },
  {
    path: '/bet/fc3d',
    name: 'bet-fc3d',
    component: () => import('../views/Fc3dBetView.vue'),
  },
  {
    path: '/bet/dlt',
    name: 'bet-dlt',
    component: () => import('../views/DltBetView.vue'),
  },
  {
    path: '/bet/ssq',
    name: 'bet-ssq',
    component: () => import('../views/SsqBetView.vue'),
  },
  {
    path: '/fastThree/redBlack',
    redirect: (to) => ({ path: '/bet/tc-k3', query: { ...to.query, id: to.query.id || 1909, menu: 'rb' } })
  },
  {
    path: '/fastThree/dragonTiger',
    redirect: (to) => ({ path: '/bet/tc-k3', query: { ...to.query, id: to.query.id || 1909, menu: 'lhh' } })
  },
  {
    path: '/fastThree/span',
    redirect: (to) => ({ path: '/bet/tc-k3', query: { ...to.query, id: to.query.id || 1909, menu: 'span' } })
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('../views/CartView.vue'),
  },
  {
    path: '/roadmap',
    name: 'roadmap',
    component: RoadmapView,
  },
  {
    path: '/chase',
    name: 'chase',
    component: ChaseView,
  },
  {
    path: '/long-dragon',
    name: 'long-dragon',
    component: () => import('../views/LongDragonView.vue'),
  },
  {
    path: '/trend',
    name: 'trend',
    component: TrendView,
  },
  {
    path: '/trend/tc-lhc',
    name: 'trend-tc-lhc',
    component: () => import('../views/TcLhcTrendView.vue'),
  },
  {
    path: '/trend/tc-keno8',
    name: 'trend-tc-keno8',
    component: () => import('../views/TcKeno8TrendView.vue'),
  },
  {
    path: '/record',
    name: 'record',
    component: RecordView,
  },
  {
    path: '/about',
    name: 'about',
    redirect: '/',
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  const isAdmin = to.path.startsWith('/admin')
  document.documentElement.classList.toggle('admin-html', isAdmin)
  if (isAdmin) document.documentElement.classList.remove('night')
  const token = localStorage.getItem('admin-token')
  if (isAdmin && !to.meta.public && !token) return '/admin/login'
  if (to.path === '/admin/login' && token) return '/admin/dashboard'

  // 控彩范围：投注/走势页若当前彩种不在允许列表，跳到允许的第一款
  try {
    const raw = localStorage.getItem('lgw-allowed-game-ids')
    if (raw) {
      let allowed = JSON.parse(raw)
        .map(Number)
        .filter((n) => n > 0)
      // 低频成组补齐（与 session.getAllowedGameIds 一致）
      const lf = [14, 15, 16, 17]
      if (allowed.some((id) => lf.includes(id))) {
        allowed = [...new Set([...allowed, ...lf])]
      }
      if (allowed.length) {
        const qid = Number(to.query.id || 0)
        const pathId =
          to.path === '/bet/tc-keno8'
            ? 21503
            : to.path === '/bet/tc-lhc'
              ? 1103
              : to.path === '/bet/tc-k3'
                ? 1909
                : to.path === '/bet/fc3d'
                  ? 14
                  : to.path === '/bet/dlt'
                    ? 16
                    : to.path === '/bet/ssq'
                      ? 17
                      : 0
        const effective = qid || pathId
        if (
          (to.path.startsWith('/bet') || to.path.startsWith('/trend')) &&
          effective > 0 &&
          !allowed.includes(effective)
        ) {
          const only = allowed[0]
          const path =
            only === 14
              ? '/bet/fc3d'
              : only === 16
                ? '/bet/dlt'
                : only === 17
                  ? '/bet/ssq'
                  : only === 1103
                    ? '/bet/tc-lhc'
                    : only === 1909
                      ? '/bet/tc-k3'
                      : only === 21503
                        ? '/bet/tc-keno8'
                        : '/bet'
          return { path, query: { id: only } }
        }
      }
    }
  } catch (_) {}

  if (to.path === '/bet' && Number(to.query.id) === 1103) {
    return { path: '/bet/tc-lhc', query: { id: 1103 } }
  }
  if (to.path === '/bet' && Number(to.query.id) === 14) {
    return { path: '/bet/fc3d', query: { id: 14 } }
  }
  if (to.path === '/bet' && Number(to.query.id) === 16) {
    return { path: '/bet/dlt', query: { id: 16 } }
  }
  if (to.path === '/bet' && Number(to.query.id) === 17) {
    return { path: '/bet/ssq', query: { id: 17 } }
  }
  if (to.path === '/bet' && Number(to.query.id) === 1909) {
    return { path: '/bet/tc-k3', query: { id: 1909, menu: 'rb', mode: 'entertainment' } }
  }
  // 天成快三：无 menu 时默认进入红黑组合
  if (to.path === '/bet/tc-k3' && (to.query.menu == null || to.query.menu === '')) {
    return {
      path: '/bet/tc-k3',
      query: {
        ...to.query,
        id: to.query.id || 1909,
        menu: 'rb',
        mode: to.query.mode || 'entertainment'
      }
    }
  }
  if (to.path === '/bet' && Number(to.query.id) === 21503) {
    return { path: '/bet/tc-keno8', query: { id: 21503 } }
  }
  if (to.path === '/trend' && Number(to.query.id) === 1103) {
    return { path: '/trend/tc-lhc', query: { id: 1103 } }
  }
  if (to.path === '/trend' && Number(to.query.id) === 21503) {
    return { path: '/trend/tc-keno8', query: { id: 21503 } }
  }
})

export default router
